import {
  GenericDocumentLocales,
  NonGenericDocumentLocales,
} from 'features/Onboarding/shineStartTypes';

import {
  CompanyCreationDocumentType,
  ShineStartDocumentType,
} from '../../../../../__generated__/GQL';
import documentTypeProperties from './documentTypeProperties';
import genericDocumentLocales from './genericDocumentLocales';
import { UploadableDocumentType } from './types';

const getDocumentLocales = (document: {
  type: ShineStartDocumentType | CompanyCreationDocumentType;
  typeLocalized?: string | null;
}): NonGenericDocumentLocales | GenericDocumentLocales => {
  if (document.type !== null && document.type in documentTypeProperties) {
    return documentTypeProperties[document.type as UploadableDocumentType]
      .locales;
  }
  // Otherwise this document is generic (PROOF_OF_IDENTITY_HAND_WRITTEN is handled elsewhere)
  const documentName =
    document.typeLocalized ?? genericDocumentLocales.fallbackDocumentName;

  return {
    ...genericDocumentLocales,
    documentName,
  };
};

export default getDocumentLocales;
